import ThankYouBanner from 'components/tailgrids-ui/thank-you/thank-you-banner';
import React from 'react';

export default function ThankYouBannerTastic({ data }) {
  return <ThankYouBanner {...data} />;
}
